import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const SearchBarWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 0 0 ${theme.spacing.xSmall}px;
  position: sticky;
  top: 0;
  z-index: 1;

  .search-icon {
    position: absolute;
    left: ${theme.spacing.xSmall}px;
    top: 10px;
    z-index: 1;

    path {
      fill: ${theme.colors.controlBorder};
    }
  }

  .clear-btn {
    position: absolute;
    right: ${theme.spacing.lg}px;
  }

  .search-bar {
    width: 100%;
    border-radius: 28px;
    height: 40px;
  }

  .MuiOutlinedInput-input {
    border-radius: ${theme.attributes.borderRadius.small};
    border: 1px solid ${theme.colors.controlBorder};
    background: ${theme.colors.frameworkCardBg};
    height: 40px;
    padding: 0 50px 0 36px;
    color: ${theme.colors.btnSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 24px;
    letter-spacing: 0.5px;

    &::placeholder {
      color: ${theme.colors.textSecondaryLow};
      opacity: 1;
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: normal;
    }

    &:focus {
      border-color: ${theme.colors.cta};
    }
  }

  fieldset {
    border: none;
  }
`
